import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {HashRouter as Router} from 'react-router-dom';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import {ConfigProvider} from 'antd';
import App from '@/modules/App';
import {THEME} from '@/dicts/antd-theme';

// import '@/mock';

import '@/styles';

const main = () => {
    const container = document.getElementById('main');
    if (!container) {
        throw new Error('找不到 #main 元素');
    }

    const root = createRoot(container);
    root.render(
        <StrictMode>
            <Router>
                <ConfigProvider theme={THEME} locale={zhCN}>
                    <App />
                </ConfigProvider>
            </Router>
        </StrictMode>
    );
};

main();
